document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.quick-share').forEach((root) => {

        const showTip = (btn, msg) => {
            if (!btn) return;

            const tip = btn.querySelector('.qs-tip');
            if (tip && msg) tip.textContent = msg;

            btn.classList.add('is-copied');

            clearTimeout(btn._tipT);
            btn._tipT = setTimeout(() => {
                btn.classList.remove('is-copied');
            }, 1800);
        };

        // Copy helper with fallback
        const copyToClipboard = async (text) => {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                    return true;
                }
            } catch (e) {}

            try {
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.setAttribute('readonly', 'readonly');
                ta.style.position = 'fixed';
                ta.style.left = '-9999px';
                document.body.appendChild(ta);
                ta.select();
                const ok = document.execCommand('copy');
                document.body.removeChild(ta);
                return ok;
            } catch (e) {
                return false;
            }
        };

        const isLikelyMobile = () => {
            return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
        };

        const openSharePopup = (url, name = 'share', w = 640, h = 720) => {
            const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

            const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
            const height = window.innerHeight || document.documentElement.clientHeight || screen.height;

            const left = Math.max(0, (width - w) / 2 + dualScreenLeft);
            const top = Math.max(0, (height - h) / 2 + dualScreenTop);

            const features = [
                `width=${w}`,
                `height=${h}`,
                `left=${Math.round(left)}`,
                `top=${Math.round(top)}`,
                'scrollbars=yes',
                'resizable=yes',
                'toolbar=no',
                'location=no',
                'status=no',
                'menubar=no',
                'noopener=yes',
                'noreferrer=yes',
            ].join(',');

            const win = window.open(url, name, features);

            if (win) {
                try { win.opener = null; } catch (e) {}
                win.focus();
            }

            return !!win;
        };

        // 1) Copy link (tooltip)
        root.querySelectorAll('.js-share-copy').forEach((btn) => {
            btn.addEventListener('click', async () => {
                const url = btn.getAttribute('data-share-url') || window.location.href;
                const ok = await copyToClipboard(url);
                showTip(btn, ok ? 'Link kopiert' : 'Kopieren fehlgeschlagen');
            });
        });

        // 2/3) LinkedIn/Facebook popup on desktop
        root.querySelectorAll('a.js-share-popup').forEach((a) => {
            a.addEventListener('click', (e) => {
                if (isLikelyMobile()) return;

                const href = a.getAttribute('href') || a.getAttribute('data-popup-url');
                if (!href) return;

                e.preventDefault();

                const type = a.getAttribute('data-share-popup') || 'share';
                const ok = openSharePopup(href, `share_${type}`);

                if (!ok) {
                    window.open(href, '_blank', 'noopener,noreferrer');
                }
            });
        });

    });
});
